module.exports = __webpack_public_path__ + "img/controlEngineering_sign.241be47e.png";